/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:48:09
 * @LastEditTime: 2020-10-27 09:29:26
 * @Description: 销售项目store
 */
import {
    getSales,
    getSalesById,
    updatePriceSales,
    updateSales,
    createSales,
    bindSalesWithItemCodeSales
} from '@/api/sales'
import Vue from 'vue'

import caclSalesCost from './caclSalesCost'

const state = {
    sales: [],
    totalCounts: 0
}

const getters = {
    prodRecipeSales(state) {
        return state.sale
    },
    salesById: (state) => (id) => {
        return state.sales.find(x => x._id === id)
    }
}

const actions = {
    async getSalesAction({
        commit
    }, payload) {
        try {
            const res = await getSales(payload)
            commit('SETSALES', res.data)
            return res.data
        } catch (error) {
            throw error.message
        }
    },
    async getSalesByIdAction({
        commit
    }, id) {
        try {
            const sales = await getSalesById(id)
            return sales.data
        } catch (error) {
            throw error.message
        }

    },
    async createSalesAction({
        commit
    }, payload) {
        try {
            const newSales = await createSales(payload);
            commit('ADDNEWSALES', newSales.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesAction({
        commit
    }, payload) {
        try {
            const newSales = await updateSales(payload.id, payload.data)
            commit("UPDATESALES", newSales.data)
            return newSales.data
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesPriceAction({
        commit
    }, payload) {
        try {
            const newSales = await updatePriceSales(payload.id, payload.data)
            commit('UPDATESALES', newSales.data)
            return newSales.data
        } catch (error) {
            throw error.message
        }
    },

    async setProdRecipeupdateSalesAction({
        commit
    }, payload) {
        try {
            commit('UPDATESALES', payload)
        } catch (error) {
            throw error.message
        }
    },

    async bindSalesWithItemCodeSalesAction({
        commit
    }, payload) {
        try {
            const newSales = await bindSalesWithItemCodeSales(payload);
            // commit('BIND_SALES_WITH_ITEM_CODE_SALES', newSales.data)
        } catch (error) {
            throw error.message
        }
    },
    updateSalesWithCostAction({
        commit
    }, payload) {
        commit('UPDATE_SALES_WITH_COST', payload)
    }
}

const mutations = {
    SETSALES(state, payload) {
        state.sales = payload.salesList
        state.totalCounts = payload.totalCounts
    },
    ADDNEWSALES(state, sales) {
        state.sales.unshift(sales)
        state.totalCounts++
    },
    UPDATESALES(state, sales) {
        Vue.set(state.sales, state.sales.findIndex(x => x._id === sales._id), sales)
    },
    // 更新sales的allowSales同时更新caclSalesCost保持界面同步更新
    UPDATE_SALES_WITH_COST(state, sales) {
        const index = caclSalesCost.state.salesLatestCost.findIndex(x => x._id === sales.id)
        const salesCost = caclSalesCost.state.salesLatestCost[index]
        salesCost.allowSales = sales.allowSales === 'true';
        salesCost.prePaidOnly = sales.prePaidOnly === 'true';
        salesCost.isLimitVolPerMonth = sales.isLimitVolPerMonth === 'true';
        salesCost.limitVolPerMonth = sales.limitVolPerMonth;
        //   salesCost.salesOrderReview = sales.salesOrderReview
        Vue.set(caclSalesCost.state.salesLatestCost, index, salesCost);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}